import { Injectable } from '@angular/core';
import { exportToXlsx } from 'src/app/utils/utils.common';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor() { }
  genCapacityPlanning(equipments, fleetList): void {
    const table = [
      [
        "Rig#",
        "Space Type",
        "Rig Type",
        ...equipments.map(equipment => equipment.title)
      ]];
    fleetList.forEach(fleet => {
      let data = [
        fleet.setiDecall ? fleet.setiDecall : ' ',
        (fleet.losDetails && fleet.losDetails.title) ? fleet.losDetails.title : ' ',
        fleet.driverCarModel ? fleet.driverCarModel : ' ',

      ]
      equipments.forEach(equipment => {
        const hasEquipment = fleet.equipments.includes(equipment._id);
        data.push(hasEquipment ? 'true' : ' ');
      });

      table.push(data)
    });

    exportToXlsx(`equipment-planning`, table);
  }





}
